import React, { useState } from 'react'
import Layout from '../../layout'
import { Loader } from '../../loader'
import { useTranslation } from "react-i18next";
import Header from '../../layout/Header';
import { useParams } from "react-router-dom";
export const TermsandConditions = () => {
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  return (
    <>
      <Header />
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card border-0">
            <div className="card-body px-2 pt-0 pb-2">

              <div className="container mt-3">
                <p className='programDetailsText'>
                  {t("termsAndConditions")}
                </p>
                <p className='border-b'></p>

                <ul className='mt-2 conditionsText'>
                  <li className='list-style-disc'>
                    {t("condition1")}
                  </li>
                  <li className='list-style-disc'>
                    {t("condition2")}
                  </li>
                  <li className='list-style-disc'>
                    {t("condition3")}
                  </li>
                  <li className='list-style-disc'>
                    {t("condition4")}
                  </li>
                  <li className='list-style-disc'>
                    {t("condition5")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition6")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition7")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition8")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition9")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition10")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition12")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition13")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition14")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition15")}
                  </li>

                  <li className='list-style-disc'>
                    {t("condition16")}
                  </li> 
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
